/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
} from '@azure/msal-angular';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbTreeGridModule,
  NbWindowModule,
} from '@nebular/theme';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  TimeagoClock,
  TimeagoCustomFormatter,
  TimeagoFormatter,
  TimeagoIntl,
  TimeagoModule,
} from 'ngx-timeago';
import { Observable, interval } from 'rxjs';
import { ThemeModule } from './@theme/theme.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AnalyticsService } from './common/services/analytics.service';
import { AppConfigService } from './common/services/app-config/app-config.service';
import { HttpErrorInterceptor } from './common/services/interceptors/http-error.interceptor';
import { InsertAuthTokenInterceptor } from './common/services/interceptors/insert-auth-token-interceptor';
import { LocaleProvider } from './common/services/locale.provider';
import { SeoService } from './common/services/seo.service';
import { RouteReuseStrategy, TitleStrategy } from '@angular/router';
import { CustomPageTitleStrategy } from './common/services/custom-page-title-strategy';
import { CustomRouteReuseStrategy } from './common/services/custom-route-reuse-strategy';
registerLocaleData(localeDe, 'de');

export function rootLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export const appInitializerFn = (appConfigService: AppConfigService) => {
  return () => {
    return appConfigService.loadAppConfig();
  };
};

export class MyClock extends TimeagoClock {
  tick(then: number): Observable<number> {
    return interval(5000);
  }
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    NbTreeGridModule,
    ThemeModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'de',
      loader: {
        provide: TranslateLoader,
        useFactory: rootLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MsalModule,
    /*MsalModule.forRoot(
      new PublicClientApplication(authConfig()),
      guardConfig(),
      interceptorConfig()
    )*/ TimeagoModule.forRoot({
      clock: { provide: TimeagoClock, useClass: MyClock },
      intl: { provide: TimeagoIntl },
      formatter: {
        provide: TimeagoFormatter,
        useClass: TimeagoCustomFormatter,
      },
    }),
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService],
    },
    SeoService,
    AnalyticsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InsertAuthTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    /*{
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },*/

    MsalService,
    MsalGuard,
    MsalBroadcastService,

    LocaleProvider,
    { provide: TitleStrategy, useClass: CustomPageTitleStrategy },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
